// https://getbootstrap.com/docs/5.0/forms/form-control/

import { is } from '@common/is/is'

interface IProps {
  readonly id?: string
  readonly value?: string
  readonly name?: string
  readonly rows?: number
  readonly spellcheck?: boolean
  readonly isDisabled?: boolean
  readonly isReadonly?: boolean
  readonly placeholder?: string
  readonly isValid?: boolean | undefined
  readonly onInput?: (e: Event) => void
  readonly onKeyUp?: (e: KeyboardEvent) => void
  readonly onKeyDown?: (e: KeyboardEvent) => void
  readonly onPaste?: (e: ClipboardEvent) => void
  readonly children?: unknown
  readonly maxLength?: number
}

/**
 * Bootstrap-alapú textarea komponens.
 * @param props - JSX props {@link IProps}.
 */
export default function Textarea (props: IProps): HTMLTextAreaElement {
  /* eslint-disable custom/no-nested-ternary -- Legacy. */
  const validateClass = is.boolean(props.isValid)
    ? props.isValid
      ? 'is-valid'
      : 'is-invalid'
    : ''
  /* eslint-enable custom/no-nested-ternary */

  const cn: readonly string[] = [ 'form-control', validateClass ]

  const ta: HTMLTextAreaElement = <textarea className={ cn } />

  if (is.number(props.maxLength)) {
    ta.maxLength = props.maxLength
  }

  if (props.id) {
    ta.id = props.id
  }

  if (props.rows) {
    ta.rows = props.rows
  }

  if (props.name) {
    ta.name = props.name
  }

  if (props.value) {
    ta.value = props.value
  }

  // Támogassuk, hogy úgy is lehessen értéket hozzáadni, hogy childrenként tesszük.
  // A sima <textarea> elemnél ez ugyanúgy működik.
  if (is.array(props.children) && is.string(props.children[0])) {
    const [ value ] = props.children
    ta.value = value
  }

  if (props.placeholder) {
    ta.placeholder = props.placeholder
  }

  if (props.isDisabled) {
    ta.disabled = props.isDisabled
  }

  if (props.isReadonly) {
    ta.readOnly = true
  }

  ta.spellcheck = is.undefined(props.spellcheck) ? false : props.spellcheck

  if (props.onInput) {
    ta.addEventListener('input', props.onInput)
  }

  if (props.onKeyUp) {
    ta.addEventListener('keyup', props.onKeyUp)
  }

  if (props.onKeyDown) {
    ta.addEventListener('keydown', props.onKeyDown)
  }

  if (props.onPaste) {
    ta.addEventListener('paste', props.onPaste)
  }

  return ta
}
